export default __webpack_public_path__ + "static/media/aether_logo_dark.bd59cf0d.png";